import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import App from './App';
import { store } from './store';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import './styles/globals.css';
// 全局错误处理
window.addEventListener('error', (event) => {
    console.error('Global error:', event.error);
    console.error('Error message:', event.message);
    console.error('Error stack:', event.error?.stack);
});
window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled promise rejection:', event.reason);
});
// 启动Mock Service Worker（开发环境）
async function enableMocking() {
    if (process.env.NODE_ENV === "development") {
        const { worker } = await import('./mocks/browser');
        return worker.start({
            onUnhandledRequest: 'bypass', // 忽略未处理的请求
        });
    }
}
console.log('Starting application...');
console.log('Environment:', process.env.NODE_ENV);
console.log('DEV mode:', process.env.NODE_ENV === "development");
enableMocking().then(() => {
    console.log('Mocking enabled (if in DEV mode)');
    console.log('Rendering React app...');
    try {
        ReactDOM.createRoot(document.getElementById('root')).render(_jsx(React.StrictMode, { children: _jsx(ErrorBoundary, { children: _jsx(Provider, { store: store, children: _jsx(HashRouter, { children: _jsx(App, {}) }) }) }) }));
        console.log('React app rendered successfully');
    }
    catch (error) {
        console.error('Failed to render React app:', error);
        document.body.innerHTML = `
      <div style="padding: 20px; font-family: Arial, sans-serif; background: #0f1419; color: #fff; min-height: 100vh;">
        <h1 style="color: #ef4444;">应用启动失败</h1>
        <p>请打开浏览器控制台查看详细错误信息</p>
        <pre style="background: #1a1f2e; padding: 10px; border-radius: 4px; overflow: auto;">${error}</pre>
      </div>
    `;
    }
}).catch((error) => {
    console.error('Failed to enable mocking:', error);
});
